import { Color } from '@diritto/common/style/color';
import { IconProps } from '@diritto/common/style/icon';

export const ClearIcon = ({ size = 16, color = Color.Gray600 }: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={(size * 17) / 16} viewBox="0 0 16 17" fill="none">
    <path
      d="M8.00016 1.8335C4.3135 1.8335 1.3335 4.8135 1.3335 8.50016C1.3335 12.1868 4.3135 15.1668 8.00016 15.1668C11.6868 15.1668 14.6668 12.1868 14.6668 8.50016C14.6668 4.8135 11.6868 1.8335 8.00016 1.8335ZM11.3335 10.8935L10.3935 11.8335L8.00016 9.44016L5.60683 11.8335L4.66683 10.8935L7.06016 8.50016L4.66683 6.10683L5.60683 5.16683L8.00016 7.56016L10.3935 5.16683L11.3335 6.10683L8.94016 8.50016L11.3335 10.8935Z"
      fill={color}
    />
  </svg>
);
